/**
 * TileGrid — responsive N-column grid of MetricTile children. Used for the
 * Appointments tiles (2 rows × 6) and any future "set of small KPI tiles".
 *
 * On phones: 2 columns; sm: 3; md: 4; lg: configurable (default 6 for the
 * Appointments mockup; falls back to `cols` prop if provided).
 */

import * as React from "react";

export interface TileGridProps {
  /** Columns at the lg breakpoint and up. Defaults to 6. */
  cols?: number;
  className?: string;
  children: React.ReactNode;
}

// Per-target-cols responsive class strings. Tailwind JIT needs full literal
// class names (no template construction), so each shape is enumerated here.
// Narrower widgets (cols=2) stay at 2 cols on every breakpoint — they're
// already inside a single dashboard column, so further sub-division is wrong.
const colsClass: Record<number, string> = {
  2: "grid-cols-2",
  3: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-3",
  4: "grid-cols-2 sm:grid-cols-4 lg:grid-cols-4",
  5: "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5",
  6: "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6",
};

export function TileGrid({ cols = 5, className = "", children }: TileGridProps) {
  const klass = colsClass[cols] ?? colsClass[5];
  // 12px gap matches the Penpot mockup.
  return <div className={`grid ${klass} gap-3 ${className}`}>{children}</div>;
}
